// Localização: frontend/src/api/notificacaoApi.js
// Serviço de API para comunicação com endpoints de notificações

import api from './api';

/**
 * Busca todas as notificações do usuário (incluindo agendamentos e assinaturas)
 * @param {object} [options] - Opções de filtro
 * @param {boolean} [options.apenas_nao_lidas] - Buscar apenas notificações não lidas
 * @param {string} [options.tipo] - Filtrar por tipo de notificação
 * @param {number} [options.limit] - Limite de resultados
 * @returns {Promise<object>} Notificações do usuário
 */
export const getNotificacoes = async (options = {}) => {
    try {
        const params = new URLSearchParams();
        if (options.apenas_nao_lidas) {
            params.append('apenas_nao_lidas', 'true');
        }
        if (options.tipo) {
            params.append('tipo', options.tipo);
        }
        if (options.limit) {
            params.append('limit', options.limit.toString());
        }

        const queryString = params.toString();
        const url = `/notificacoes${queryString ? `?${queryString}` : ''}`;
        
        const response = await api.get(url);
        return response.data;
    } catch (error) {
        console.error('[NotificacaoAPI] Erro ao buscar notificações:', error);
        // Retornar objeto vazio em caso de erro para não quebrar a UI
        return { 
            success: true, 
            notificacoes: [], 
            total: 0, 
            nao_lidas: 0, 
            tem_urgente: false 
        };
    }
};

/**
 * Marca uma notificação como lida
 * @param {number|string} notificacaoId - ID da notificação
 * @returns {Promise<object>} Resposta da operação
 */
export const marcarComoLida = async (notificacaoId) => {
    try {
        const response = await api.put(`/notificacoes/${notificacaoId}/lida`);
        return response.data;
    } catch (error) {
        console.error('[NotificacaoAPI] Erro ao marcar notificação como lida:', error);
        throw error;
    }
};

/**
 * Marca todas as notificações do usuário como lidas
 * @returns {Promise<object>} Resposta da operação
 */
export const marcarTodasComoLidas = async () => {
    try {
        const response = await api.put('/notificacoes/marcar-todas-lidas');
        return response.data;
    } catch (error) {
        console.error('[NotificacaoAPI] Erro ao marcar todas as notificações como lidas:', error);
        throw error;
    }
};

/**
 * Conta notificações não lidas do usuário
 * @returns {Promise<object>} Contagem de notificações não lidas
 */
export const contarNaoLidas = async () => {
    try {
        const response = await api.get('/notificacoes/contar-nao-lidas');
        return response.data;
    } catch (error) {
        console.error('[NotificacaoAPI] Erro ao contar notificações não lidas:', error);
        return { success: true, total: 0 };
    }
};

